// extracted by mini-css-extract-plugin
export default {"uploadImg":"CreateNews_uploadImg__+Zgy9","uploadFile":"CreateNews_uploadFile__yoSsH","uploadIcon":"CreateNews_uploadIcon__Trlj5"};